/** @format */
import logo from "../../assets/logoHT.svg";
import logo_2 from "../../assets/LotusFlower.webp";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const copyrightText = `Copyright © ${currentYear} Hoang Thanh International.`;
  return (
    <footer id="footer" className="">
      <div className="flex flex-col md:flex-row bg-[#6da4da] md:px-32 p-10 md:space-x-12 md:space-y-0 space-y-2 md:justify-around xl:hidden">
        <div className="space-y-2 pv:max-md:pb-10">
          <div className="flex space-x-4">
            <img
              src={logo}
              className="w-[80px] h-[80px] border-[1px] border-white"
            />
            <img
              src={logo_2}
              className="w-[80px] h-[80px] border-[1px] border-white"
            />
          </div>

          <p className="text-white align-text-bottom 2xl:text-[16px] text-[16px] uppercase">
            Hoang Thanh International
          </p>
          <p className="text-white align-text-bottom text-[16px]">
            {copyrightText}
          </p>
          <p className="text-white align-text-bottom text-[16px]">
            All rights reserved
          </p>
        </div>

        <div className="space-y-2 text-white 2xl:text-[18px] pv:max-md:pb-10">
          <p className="">
            3F, Ikigai Bashi Building, 1-7 Nihonbashi Odenmacho, Chuo-ku, Tokyo
          </p>

          <p className="">Tel: +81-3-5843-6593</p>
          <p className="">Fax: +81-3-6810-7436</p>
          <p className="">Email: thai@htcapital.vn</p>
        </div>
      </div>
      <div className="flex flex-col md:flex-row bg-[#6da4da] md:px-32 p-10 md:space-y-0 space-y-4 pv:max-xl:hidden">
        {/* Cột 1: Logo + text (50%) */}
        <div className="md:w-[50%] space-y-2 pv:max-md:pb-10">
          <div className="flex items-center space-x-4 ">
            <img
              src={logo}
              className="w-[80px] h-[80px] border border-white"
              alt="Logo HT"
            />
            <img
              src={logo_2}
              className="w-[80px] h-[80px] border border-white"
              alt="Logo Lotus"
            />
            <div className="text-white 2xl:text-[18px] leading-snu  ">
              <p className="uppercase">Hoang Thanh International</p>
              <p>{copyrightText}</p>
              <p> All rights reserved</p>
            </div>
          </div>
        </div>

        {/* Cột 2: Trống (20%) */}
        <div className="md:w-[10%]"></div>

        {/* Cột 3: Địa chỉ (30%) */}
        <div className="md:w-[50%] text-white 2xl:text-[18px]  pv:max-md:pb-10">
          <p>
            3F, Ikigai Bashi Building, 1-7 Nihonbashi Odenmacho, Chuo-ku, Tokyo
          </p>
          <p className="">Tel: +81-3-5843-6593</p>
          <p className="">Fax: +81-3-6810-7436</p>
          <p>Email: thai@htcapital.vn</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
